import api from './api';

// ─── Fabric Types (Level 1) ───
export const getFabricTypes = async () => {
  const { data } = await api.get('/fabrics/types');
  return data;
};
export const createFabricType = async (name) => {
  const { data } = await api.post('/fabrics/types', { name });
  return data;
};
export const updateFabricType = async (id, params) => {
  const { data } = await api.put(`/fabrics/types/${id}`, params);
  return data;
};
export const deleteFabricType = async (id) => {
  const { data } = await api.delete(`/fabrics/types/${id}`);
  return data;
};

// ─── Fabric Collections (curated groups) ───
export const getFabricCollections = async () => {
  const { data } = await api.get('/fabrics/collections');
  return data;
};
export const createFabricCollection = async (params) => {
  const { data } = await api.post('/fabrics/collections', params);
  return data;
};
export const updateFabricCollection = async (id, params) => {
  const { data } = await api.put(`/fabrics/collections/${id}`, params);
  return data;
};
export const deleteFabricCollection = async (id) => {
  const { data } = await api.delete(`/fabrics/collections/${id}`);
  return data;
};
export const updateCollectionPatterns = async (id, patternIds) => {
  const { data } = await api.put(`/fabrics/collections/${id}/patterns`, { pattern_ids: patternIds });
  return data;
};
export const updatePatternCollections = async (patternId, collectionIds) => {
  const { data } = await api.put(`/fabrics/patterns/${patternId}/collections`, { collection_ids: collectionIds });
  return data;
};
export const addPatternsToCollection = async (collectionId, patternIds) => {
  const { data } = await api.post('/fabrics/collections/add-patterns', { collection_id: collectionId, pattern_ids: patternIds });
  return data;
};

// ─── Fabric Patterns (Level 2) ───
export const getFabricPatterns = async (typeId) => {
  const params = typeId ? { type_id: typeId } : {};
  const { data } = await api.get('/fabrics/patterns', { params });
  return data;
};
export const getFabricPattern = async (id) => {
  const { data } = await api.get(`/fabrics/patterns/${id}`);
  return data;
};
export const createFabricPattern = async (params) => {
  const { data } = await api.post('/fabrics/patterns', params);
  return data;
};
export const updateFabricPattern = async (id, params) => {
  const { data } = await api.put(`/fabrics/patterns/${id}`, params);
  return data;
};
export const deleteFabricPattern = async (id) => {
  const { data } = await api.delete(`/fabrics/patterns/${id}`);
  return data;
};
export const updatePatternManufacturers = async (id, manufacturerIds) => {
  const { data } = await api.put(`/fabrics/patterns/${id}/manufacturers`, { manufacturer_ids: manufacturerIds });
  return data;
};
export const updatePatternCoatings = async (id, coatingIds) => {
  const { data } = await api.put(`/fabrics/patterns/${id}/coatings`, { coating_ids: coatingIds });
  return data;
};
export const updatePatternFeatures = async (id, featureIds) => {
  const { data } = await api.put(`/fabrics/patterns/${id}/features`, { feature_ids: featureIds });
  return data;
};
export const updatePatternStoreStatus = async (id, storeStatuses) => {
  const { data } = await api.put(`/fabrics/patterns/${id}/store-status`, { store_statuses: storeStatuses });
  return data;
};
export const bulkUpdatePatternStoreStatus = async (patternIds, storeId, status) => {
  const { data } = await api.put('/fabrics/patterns/bulk-store-status', { pattern_ids: patternIds, store_id: storeId, status });
  return data;
};
export const bulkDeletePatterns = async (patternIds) => {
  const { data } = await api.delete('/fabrics/patterns/bulk-delete', { data: { pattern_ids: patternIds } });
  return data;
};
export const updatePatternStoreMappings = async (id, storeId, mappings) => {
  const { data } = await api.put(`/fabrics/patterns/${id}/store-mappings`, { store_id: storeId, mappings });
  return data;
};

// ─── Shopify Linking ───
export const pushFabricPattern = async (id, storeId) => {
  const { data } = await api.post(`/fabrics/patterns/${id}/push`, { store_id: storeId });
  return data;
};
export const searchShopifyForPattern = async (storeId, query) => {
  const { data } = await api.get('/fabrics/patterns/search-shopify', { params: { store_id: storeId, query } });
  return data;
};
export const matchPattern = async (id, storeId, shopifyProductId) => {
  const { data } = await api.put(`/fabrics/patterns/${id}/match`, { store_id: storeId, shopify_product_id: shopifyProductId });
  return data;
};
export const unmatchPattern = async (id, storeId) => {
  const { data } = await api.put(`/fabrics/patterns/${id}/unmatch`, { store_id: storeId });
  return data;
};
export const updatePatternShopifyStatus = async (id, storeId, shopifyStatus) => {
  const { data } = await api.put(`/fabrics/patterns/${id}/shopify-status`, { store_id: storeId, shopify_status: shopifyStatus });
  return data;
};

// ─── Import / Export ───
export const importFabrics = async (items) => {
  const { data } = await api.post('/fabrics/import', { items });
  return data;
};
export const exportFabricsCsv = async () => {
  const token = localStorage.getItem('token');
  return fetch('/api/fabrics/export', { headers: { Authorization: `Bearer ${token}` } });
};
export const exportFabricsJson = async () => {
  const { data } = await api.get('/fabrics/export-json');
  return data;
};

// ─── Fabric Colors (Level 3) ───
export const getFabricColors = async (patternId) => {
  const params = patternId ? { pattern_id: patternId } : {};
  const { data } = await api.get('/fabrics/colors', { params });
  return data;
};
export const createFabricColor = async (params) => {
  const { data } = await api.post('/fabrics/colors', params);
  return data;
};
export const updateFabricColor = async (id, params) => {
  const { data } = await api.put(`/fabrics/colors/${id}`, params);
  return data;
};
export const deleteFabricColor = async (id) => {
  const { data } = await api.delete(`/fabrics/colors/${id}`);
  return data;
};
